import EventEmitter from "../utils/EventEmitter";

export default class SelectLocale extends EventEmitter {
    constructor(element) {
        super();
        this.el = element
        this.select = this.el.querySelector('select')
        this.flags = this.el.querySelectorAll('.flags .flag-wrapper')

        this.select.value = this.getCurrentURL()

        this.setLocale()
        this.events()
    }

    events() {
        this.select.addEventListener('change', (e) => {
            this.onLocaleChange(e)
        })
    }

    setLocale() {
        let locale = null
        if (this.select.options[this.select.selectedIndex]) {
            locale = this.select.options[this.select.selectedIndex].getAttribute('data-lang')
        } else if (this.select.querySelector('option.is-active')) {
            locale = this.select.querySelector('option.is-active').getAttribute('data-lang')
            this.select.querySelector('option.is-active').selected = true
        } else {
            locale = this.select.options[0].getAttribute('data-lang')
        }

        this.flags.forEach((flag) => {
            flag.classList.remove('active')
            if (flag.getAttribute('data-lang') === locale) {
                flag.classList.add('active')
            }
        })
    }

    getCurrentURL() {
        const url = new URL(window.location.href);
        return url.pathname + url.search;
    }


    onLocaleChange(e) {
        this.setLocale()
        setTimeout(() => {
            window.location.href = this.select.options[this.select.selectedIndex].value
        }, 200)
    }
}
